import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Home from '../../pages/Home';
import SoftwareDevPage from '../../pages/SoftwareDevPage/SoftwareDevPage';
import DigitalMarketingPage from '../../pages/DigitalMarketingPage/DigitalMarketingPage';
import WeDevelopmentPage from '../../pages/WeDevelopmentPage/WeDevelopmentPage';
import MobAppDevelopmentPage from '../../pages/MobAppDevPage/MobAppDevelopmentPage';
import ServicePage from '../../pages/ServicePage/ServicePage';
import EcommercePage from '../../pages/EcommercePage/EcommercePage';
import OutSourcePage from '../../pages/OutSourcePage/OutSourcePage';
import IntershipPage from '../../pages/IntershipPage/IntershipPage';
import ContactUpPage from '../../pages/ContactUs/ContactUpPage';
import AboutUsPage from '../../pages/AboutUsPage/AboutUsPage';
import CaseStudiesPage from '../../pages/CaseStudiesPage/CaseStudiesPage';
import PrivacyPolicy from '../../pages/PrivacyPolicy/PrivacyPolicy';

const allRoutes = [
  { path: "home", element: <Home /> },
  { path: "software-development", element: <SoftwareDevPage /> },
  { path: "digital-marketing", element: <DigitalMarketingPage /> },
  { path: "web-development", element: <WeDevelopmentPage /> },
  { path: "mobile-app-development", element: <MobAppDevelopmentPage /> },
  { path: "eCommerce-development", element: <EcommercePage /> },
  { path: "out-sourcing", element: <OutSourcePage /> },
  { path: "heathcare", element: <ServicePage /> },
  { path: "internship", element: <IntershipPage /> },
  { path: "services", element: <ServicePage /> },
  { path: "contact-us", element: <ContactUpPage /> },
  { path: "contact", element: <ContactUpPage /> },
  { path: "get-in-touch", element: <ContactUpPage /> },
  { path: "about-us", element: <AboutUsPage /> },
  { path: "case-studies", element: <CaseStudiesPage /> },
  { path:"privacy-policy-for-24care.ae", element:<PrivacyPolicy/> }

];

const AppRoutes = () => {
  return (
      <Routes>
        {/* Redirect root path `/` to `/home` */}
        <Route path="/" element={<Navigate to="/home" replace />} />

        {/* Map all other routes */}
        {allRoutes.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={route.element}
          />
        ))}

        {/* Catch-all 404 route */}
        <Route path="*" element={<ContactUpPage />} />
      </Routes>
  );
};

export default AppRoutes;